import { render } from "./HomeTwo.vue?vue&type=template&id=07f381de"
import script from "./HomeTwo.vue?vue&type=script&lang=js"
export * from "./HomeTwo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__